import {StyledGalleryTrigger} from './style'
import {Image01Icon} from '@/components/ui/icon/Icon'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {useTranslation} from '@/translations/i18n'

interface ProPhotosEmptyGalleryStateProps {
    uploadButton: React.ReactNode
    minimumImagesRequired: number
}

export const ProPhotosEmptyGalleryState = ({uploadButton, minimumImagesRequired}: ProPhotosEmptyGalleryStateProps) => {
    const {t} = useTranslation()

    return (
        <StyledGalleryTrigger direction="column" gap={1} align="center" justify="center" fullWidth>
            <Flexbox direction="column" gap={4} align="center" justify="center" fullWidth>
                <Image01Icon size={32} />
                <h3>{t('vetting:reordering:dropzone_label')}</h3>
            </Flexbox>

            <p>
                {t('vetting:reordering:at_least_x', {
                    count: minimumImagesRequired
                })}
            </p>

            {uploadButton}
        </StyledGalleryTrigger>
    )
}
